import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db, firebase } from "firebase/fbConfig.js"
import moment from 'moment'

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

// core components
import CustomInput from "components/CustomInput/CustomInput.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ProfilePicUpload from "components/CustomUpload/profilePicUpload"
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";
import { Grid } from "@material-ui/core";

// Forms

// Assets
import DefaultProfile from "assets/img/default-avatar.png"

// Firebase Redux Integration
import { tableToFirestoreObjects, updateFirestoreWithOneObject, updateFirestoreWithTableData, addFieldToDocument } from "store/actions/firestoreActions"
import { startSetActionsList, startToggleCompleted, setUserScore } from "store/actions/actionsActions"
import { startSetUsersList } from "store/actions/adminActions"
import { startSetMyOrdersList } from "store/actions/ordersActions"

const Transition = (props) => {
    return <Slide direction="down" {...props} />
}

class Principles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLoaded: false,
            updateProfileModal: false,
            updatePhotoModal: false,
            learnDashboardModal: false
        };
    }

    handleClickOpen = (modal) => {
        var x = [];
        x[modal] = true;
        this.setState({
            ...x,
        });
    }

    handleClose = (modal) => {
        var x = [];
        x[modal] = false;
        this.setState(x);
    }

    handleChange = (e) => {
        console.log(e)
        this.setState({
            [e.target.id]: e.target.value,
        })

        console.log(this.state)
    }

    convertZipToMarketArea = (zip) => {
        // console.log(state.zip.length)
        // console.log(state.zip.length == 3 ? zip.substring(0, 3) : null)

        if (zip.length >= 3) {
            var newArray = this.state.marketAreasData.filter(function (marketArea) {
                return marketArea.zips.includes(zip.substring(0, 3))
            });
            this.setState({
                filteredMarketAreas: newArray
            })
        }
    }

    loadData = (uid) => {
        let data = db.collection("marketareas")
            .get().then((snapshot) => {
                //console.log(snapshot)
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        id: doc.id,
                        ...docData
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                data
                this.setState({
                    marketAreasData: data,
                    marketAreasDataLoaded: true,
                })
            })
    }

    // Load data for Table
    // if there are no actions make a default one



    render() {
        const { AuthBool, classes, authUser, user, orders, assessments } = this.props;
        console.log(this.state)

        if (!this.state.marketAreasDataLoaded) {
            //console.log(authUser.uid)
            this.loadData()
            // console.log(user)
            // console.log(user.levelUpdatedAt.toDate())
            // console.log(moment(user.levelUpdatedAt.toDate()).format('MM-DD-YYYY'))  
        }


        return (
            <Card>
                <GridContainer justify="center">
                    <GridItem xs={11}>

                Convert Zip to Market Area
                <CustomInput
                    labelText="ZIP"
                    id="zip"
                    formControlProps={{
                        fullWidth: true
                    }}
                    inputProps={{
                        required: true,
                        type: "text",
                        onChange: (event) => this.handleChange(event)
                    }}
                />
                {this.state.zip &&
                    <div>
                        {this.state.zip.length >= 3 &&
                            <Button
                                style={{}}
                                color="primary"
                                onClick={() => this.convertZipToMarketArea(this.state.zip)}
                            >CONVERT TO MARKETAREA</Button>
                        }
                    </div>
                }
                {this.state.filteredMarketAreas &&
                    <div>
                        {this.state.filteredMarketAreas[0].fullName} | {this.state.filteredMarketAreas[0].parent.id}
                    </div>
                }
            </GridItem>
            </GridContainer>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        AuthBool: !!state.auth.user,
        authUser: state.auth.user,
        user: state.profile.user,
        assessments: state.assessment,
    }
}

const mapDispatchToProps = (dispatch, props) => {
    //console.log(props.uid)
    return {
        // startSetMyOrdersList: dispatch(startSetMyOrdersList(props.uid))
    }
}


// const mapDispatchToProps = (dispatch) => {
//   return {
//     setUserScore: (score) => dispatch(setUserScore(score))
//   }
// }

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
)(Principles);


// WEBPACK FOOTER //
// ./src/views/Actions/MarketAreaConverter.jsx